import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import agent from "../api/agent";
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { FAMDetailsDto } from "../models/famDetails/famDetailsDto";
import { FamEnrolmentYear } from "../models/famDetails/famEnrolmentYear";

interface famDataState {
    famDetails: FAMDetailsDto | null;
    famEnrolments: FamEnrolmentYear[] | null;
    famCurrentYear: number | null;
    famDetailsStatus: ApiRequestStatus;
    famEnrolmentsStatus: ApiRequestStatus;
    famCurrentYearStatus: ApiRequestStatus;
}

const initialState: famDataState = {
    famDetails: null,
    famEnrolments: null,
    famCurrentYear: null,
    famDetailsStatus: ApiRequestStatus.Idle,
    famEnrolmentsStatus: ApiRequestStatus.Idle,
    famCurrentYearStatus: ApiRequestStatus.Idle
}

export const getFamDetailsAsync = createAsyncThunk<FAMDetailsDto, string>(
    'fam/getFamDetailsAsync',
    async (personId, thunkAPI) => {
        try {
            return agent.famDetails.getFamDetailsAsync(personId);
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const getFamEnrolmentsAsync = createAsyncThunk<FamEnrolmentYear[], string>(
    'pcsSlice/getFamEnrolmentsAsync',
    async (personId, thunkAPI) => {
        try {
            return agent.famDetails.getFamEnrolmentsAsync(personId);
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const getFamCurrentYearAsync = createAsyncThunk<number>(
    'pcsSlice/getFamCurrentYearAsync',
    async (_, thunkAPI) => {
        try {
            return agent.famDetails.getFamCurrentYearAsync();
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const famSlice = createSlice({
    name: 'famSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getFamDetailsAsync.pending, (state) => {
            state.famDetailsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getFamDetailsAsync.fulfilled, (state, action) => {
            state.famDetails = action.payload;
            state.famDetailsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(getFamDetailsAsync.rejected, (state) => {
            state.famDetailsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(getFamEnrolmentsAsync.pending, (state) => {
            state.famEnrolmentsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getFamEnrolmentsAsync.fulfilled, (state, action) => {
            state.famEnrolmentsStatus = ApiRequestStatus.Fulfilled;
            state.famEnrolments = action.payload;
        });
        builder.addCase(getFamEnrolmentsAsync.rejected, (state) => {
            state.famEnrolmentsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(getFamCurrentYearAsync.pending, (state) => {
            state.famCurrentYearStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getFamCurrentYearAsync.fulfilled, (state, action) => {
            state.famCurrentYearStatus = ApiRequestStatus.Fulfilled;
            state.famCurrentYear = action.payload;
        });
        builder.addCase(getFamCurrentYearAsync.rejected, (state) => {
            state.famCurrentYearStatus = ApiRequestStatus.Rejected;
        });
    })
})
